import React from "react";
import { useTranslation } from "react-i18next";

import { ConfirmationAlert } from "../../../../../cargotic-webapp-component";

const ExchangeRateDeleteConfirmationAlert = ({
  isOpen,
  onClose,
  onSubmit
}) => {
  const { t } = useTranslation();

  return (
    <ConfirmationAlert
      title={t("webapp:settings.title.deleteExchangeRate")}
      content={t("webapp:settings.prompt.delete-exchange-rate")}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
};

export default ExchangeRateDeleteConfirmationAlert;
